import React from 'react';
import AppLayout from 'layouts/AppLayout';
import Icon from 'components/AppIcon';

/**
 * Permissions — Administration section
 * Placeholder page for role-based access control configuration.
 * Scheduled for Phase 2 implementation.
 */
export default function PermissionsPage() {
  return (
    <AppLayout>
      <div className="px-4 md:px-6 lg:px-8 py-10">
        <div className="max-w-2xl mx-auto text-center">
          <div
            className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6"
            style={{ background: 'var(--color-primary)', opacity: 0.9 }}
          >
            <Icon name="ShieldCheck" size={28} color="white" strokeWidth={1.8} />
          </div>
          <h1
            className="font-heading font-semibold text-foreground mb-3"
            style={{ fontSize: '1.75rem', lineHeight: 1.25 }}
          >
            Permissions
          </h1>
          <p className="font-caption text-muted-foreground mb-2" style={{ fontSize: '1rem', lineHeight: 1.6 }}>
            Role-based access control and permission management.
          </p>
          <p className="font-caption text-muted-foreground" style={{ fontSize: '0.875rem' }}>
            This module is scheduled for Phase 2. It will allow platform administrators
            to configure granular permissions, manage role assignments, and review access
            audit logs across the SeedDrive platform.
          </p>
          <div
            className="inline-flex items-center gap-2 mt-6 px-4 py-2 rounded-full text-sm font-medium font-caption"
            style={{
              background: 'var(--color-muted)',
              color: 'var(--color-muted-foreground)',
            }}
          >
            <Icon name="Clock" size={14} color="currentColor" strokeWidth={2} />
            Coming in Phase 2
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
